module.exports = __webpack_public_path__ + "img/catstagram-details2.fc01863e.png";